import {IGetResult, ILoginByCodeAndPassword, IUpdateProfileRequest, IUser} from "@/types/api.ts";
import {useAxios} from "@vueuse/integrations/useAxios";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {API_URLS} from "@/utils/constants/api-urls.ts";
import {useAuthStore} from "@/store/auth-store.ts";
import router from "@/router";

export class EmailAuthService {
  static getInstance(): EmailAuthService {
    return new EmailAuthService();
  }

  fetchCurrentUser = async (): Promise<IUser | undefined> => {
    const {execute, data} = useAxios<IGetResult>(API_URLS.auth.me, {
      method: "get"
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.user;
  }

  async logOut() {
    const {execute} = useAxios<IGetResult>(API_URLS.auth.logout, {
      method: "delete"
    }, axiosInstance, {immediate: false})
    await execute();
    useAuthStore().logout();
    await router.push("/")
  }

  loginByGoogle() {
    window.location.href = API_URLS.auth.googleLogin;
  }

  async updateProfile(user: IUpdateProfileRequest) {
    await useAxios<IGetResult>(API_URLS.users.updateById(user._id), {
      method: "PATCH",
      data: user
    }, axiosInstance, {immediate: false}).execute()
  }

  async loginByCodeAndPassword(body: ILoginByCodeAndPassword) {
    const {execute, data} = useAxios<IGetResult>(API_URLS.auth.loginByCodeAndPassword, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }
}